import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { IMenuItem } from '../../utils/constants/menuItems';
import { Routes } from '../../utils/constants/routes';
import { Roles } from '../../utils/enums';

interface ProfileDropDownProps {
    menuItems?: Array<IMenuItem>;
    enableDropDown?: boolean;
    iconUrl?: string;
    activeRole: string;
    handleChangeRole: any;
    allowedRoles: Roles[];
}

const FAQ_URL = 'https://docs.google.com/document/d/12QGJk3EUOrYOIGKuulchF1JBbw4TVKmluwSF8BlM6NI/edit';

const ProfileDropDown = ({ menuItems, enableDropDown, iconUrl, activeRole, handleChangeRole, allowedRoles }: ProfileDropDownProps) => {
    const [openDowndown, setPpenDowndown] = useState(false);
    const handleDropdownOpen = () => setPpenDowndown(!openDowndown);

    const closeProfileDrowdown = () => {
        setPpenDowndown(false);
    };

    const history = useHistory();

    const handleLogout = () => {
        localStorage.clear();
        history.replace(Routes.LOGIN);
    };

    return (
        <div className="relative inline-block text-left">
            <div>
                <button
                    type="button"
                    className="flex items-center justify-center w-full rounded-md text-sm font-medium text-gray-700 dark:text-gray-50 hover:bg-gray-50 dark:hover:bg-gray-500 focus:outline-none"
                    id="options-menu"
                    onClick={handleDropdownOpen}
                >
                    {iconUrl ? (
                        <img src={iconUrl} alt="" className="rounded-full w-8 h-8 object-fill" />
                    ) : (
                        <svg width="20" fill="currentColor" height="20" className="text-gray-800" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1523 1339q-22-155-87.5-257.5t-184.5-118.5q-67 74-159.5 115.5t-195.5 41.5-195.5-41.5-159.5-115.5q-119 16-184.5 118.5t-87.5 257.5q106 150 271 237.5t356 87.5 356-87.5 271-237.5zm-243-699q0-159-112.5-271.5t-271.5-112.5-271.5 112.5-112.5 271.5 112.5 271.5 271.5 112.5 271.5-112.5 112.5-271.5zm512 256q0 182-71 347.5t-190.5 286-285.5 191.5-349 71q-182 0-348-71t-286-191-191-286-71-348 71-348 191-286 286-191 348-71 348 71 286 191 191 286 71 348z"></path>
                        </svg>
                    )}
                </button>
            </div>
            {openDowndown && (
                <div className="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white dark:bg-gray-800 ring-1 ring-black ring-opacity-5">
                    <div className="py-1 " role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                        <div className=" ">
                            <div className="flex items-center py-3 px-3 border-b">
                                <div className="svg mr-2">
                                    <svg fill="#000000" width="16" height="16" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M512 0C229.232 0 0 229.232 0 512c0 282.784 229.232 512 512 512 282.784 0 512.017-229.216 512.017-512C1024.017 229.232 794.785 0 512 0zm0 961.008c-247.024 0-448-201.984-448-449.01 0-247.024 200.976-448 448-448s448.017 200.977 448.017 448S759.025 961.009 512 961.009zm-47.056-160.529h80.512v-81.248h-80.512zm46.112-576.944c-46.88 0-85.503 12.64-115.839 37.889-30.336 25.263-45.088 75.855-44.336 117.775l1.184 2.336h73.44c0-25.008 8.336-60.944 25.008-73.84 16.656-12.88 36.848-19.328 60.56-19.328 27.328 0 48.336 7.424 63.073 22.271 14.72 14.848 22.063 36.08 22.063 63.664 0 23.184-5.44 42.976-16.368 59.376-10.96 16.4-29.328 39.841-55.088 70.322-26.576 23.967-42.992 43.231-49.232 57.807-6.256 14.592-9.504 40.768-9.744 78.512h76.96c0-23.68 1.503-41.136 4.496-52.336 2.975-11.184 11.504-23.823 25.568-37.888 30.224-29.152 54.496-57.664 72.88-85.551 18.336-27.857 27.52-58.593 27.52-92.193 0-46.88-14.176-83.408-42.577-109.568-28.416-26.176-68.272-39.248-119.568-39.248z" />
                                    </svg>
                                </div>

                                <button>
                                    <a href={FAQ_URL} target="_blank" rel="noreferrer">
                                        <p className="text-sm text-gray-400">FAQ's</p>
                                    </a>
                                </button>
                            </div>

                            <div onClick={handleLogout} className="flex items-center  py-3 px-3 cursor-pointer ">
                                <div className="svg mr-2">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M14.1667 5.83333L12.9917 7.00833L15.1417 9.16667H6.66669V10.8333H15.1417L12.9917 12.9833L14.1667 14.1667L18.3334 10L14.1667 5.83333ZM3.33335 4.16667H10V2.5H3.33335C2.41669 2.5 1.66669 3.25 1.66669 4.16667V15.8333C1.66669 16.75 2.41669 17.5 3.33335 17.5H10V15.8333H3.33335V4.16667Z"
                                            fill="#E32727"
                                        />
                                    </svg>
                                </div>
                                <p className=" text-xs text-red-500 ">Logout</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProfileDropDown;
